import { assertNever } from '../../../assertNever';
import { Temporal } from '../../../Temporal';

type TransparentlySerializeableDueInstance = DueUnset | DueNever;

export type SerializedDueInstance = TransparentlySerializeableDueInstance | SerializedDueOnDate;
export type DueInstance = TransparentlySerializeableDueInstance | DueOnDate;

interface DueUnset {
  type: 'dueUnset';
}

interface SerializedDueOnDate {
  type: 'dueOnDate';
  timestamp: Temporal.ZonedDateTimeLike | string;
  hasOccurred: boolean;
}

interface DueOnDate extends SerializedDueOnDate {
  timestamp: Temporal.ZonedDateTime;
}

interface DueNever {
  type: 'dueNever';
}

export function reviveDueInstance(serialized: SerializedDueInstance): DueInstance {
  switch (serialized.type) {
    case 'dueOnDate':
      return {
        type: 'dueOnDate',
        timestamp: Temporal.ZonedDateTime.from(serialized.timestamp),
        hasOccurred: serialized.hasOccurred,
      };
    default:
      return serialized;
  }
}

export function getDueTimestamp(dueInstance: DueInstance): Temporal.ZonedDateTime | undefined {
  switch (dueInstance.type) {
    case 'dueUnset':
    case 'dueNever':
      return undefined;
    case 'dueOnDate':
      return dueInstance.timestamp;
    default:
      return assertNever(dueInstance);
  }
}
